export default __webpack_public_path__ + "static/media/project-status-active.4b94a957.svg";